export default __webpack_public_path__ + "static/media/payment-success.75ec9701.svg";